export interface ProductImageVariant {
  url: string;
  width: number;
  height: number;
}

export type ProductImageVariants = Partial<Record<'400' | '800' | '1600', ProductImageVariant>>;

export function responsiveProductImageAttributes(
  imageUrl?: string | null,
  variants?: ProductImageVariants | null,
): { src: string | null; srcSet?: string } {
  const entries = Object.values(variants ?? {}).filter(
    (variant): variant is ProductImageVariant =>
      Boolean(variant) &&
      typeof variant.url === 'string' &&
      variant.url.trim().length > 0 &&
      Number.isFinite(variant.width) &&
      variant.width > 0,
  );

  // A small source can produce several nominal breakpoints with the same
  // actual width. Keep one URL per width so the browser receives a valid set.
  const byWidth = new Map<number, string>();
  for (const variant of entries) byWidth.set(variant.width, variant.url);
  const candidates = [...byWidth.entries()].sort(([left], [right]) => left - right);
  const preferred = variants?.['800']?.url ?? variants?.['1600']?.url ?? variants?.['400']?.url;

  return {
    src: preferred ?? imageUrl ?? null,
    ...(candidates.length > 1
      ? { srcSet: candidates.map(([width, url]) => `${url} ${width}w`).join(', ') }
      : {}),
  };
}
